module.exports = "/img/_/_/_/assets/images/creeper/book/common//4.jpg?8ad1cecdf646af280742b59441c7f9b5";